<mat-sidenav-container class="sidenav-container" autosize="true">
    @if (showSidenav()) {
        <mat-sidenav #sidenav mode="side" opened class="sidenav">
            <mat-action-list (click)="expanded.set(!expanded())">
                <button mat-list-item id="sidenav-main-title" [class.sidenav-collapsed]="!expanded()" type="button">
                    @if (expanded()) {
                        <fa-icon [icon]="faBars" />{{ sidenavMainTitle() }}
                    } @else {
                        <fa-icon [icon]="faBars" />
                    }
                </button>
            </mat-action-list>

            @if (expanded() && sidenavFolders().length) {
                <!-- Whenever we want to try this file tree for real, perhaps remove OnPush first and clean up the file tree-->
                <!-- Cypress Component Tests seem fine-->
                <r1-compass-lib-file-tree file-tree [data]="sidenavFolders()" />
            }

            <mat-nav-list>
                @for (link of links(); track $index) {
                    <mat-list-item
                        queryParamsHandling="merge"
                        routerLinkActive="active-list-item"
                        [routerLink]="
                            !routingService.routeDisabledUntilAssetCreated() && !divisionSettingsDisabled()
                                ? link.url
                                : null
                        "
                        [disabled]="routingService.routeDisabledUntilAssetCreated() || divisionSettingsDisabled()"
                        [class.sidenav-collapsed]="!expanded()">
                        <!-- Salesforce needed own package + prefix -->
                        @let faType = link.icon === 'salesforce' ? 'fab' : 'fas';
                        @if (expanded()) {
                            <a matListItemTitle class="sidenav-link">
                                <div class="sidenav-link-label">
                                    <fa-icon [icon]="[faType, link.icon]" />
                                    {{ link.title }}
                                </div>
                                <div
                                    class="sidenav-validation-indicator"
                                    [style.visibility]="link.hasValidationIssue ? 'visible' : 'hidden'">
                                    <fa-icon [icon]="['fas', 'triangle-exclamation']" style="color: var(--r1-orange)" />
                                </div>
                            </a>
                        } @else {
                            <fa-icon [icon]="[faType, link.icon]" />
                        }
                    </mat-list-item>
                }
                <mat-divider />
                @if (expanded()) {
                    <div mat-subheader>Support</div>
                }
                <a
                    [class.sidenav-collapsed]="!expanded()"
                    href="https://corpit-thermofisher.atlassian.net/wiki/spaces/DSP/pages/41592063/Compass+User+Guide"
                    target="_blank"
                    mat-list-item>
                    <fa-icon [icon]="['fas', 'book-bookmark']" />
                    @if (expanded()) {
                        Compass User Guide
                    }
                </a>
                <a
                    [class.sidenav-collapsed]="!expanded()"
                    href="https://corpit-thermofisher.atlassian.net/wiki/spaces/DSP/pages/41591821/Getting+Help+and+Support"
                    target="_blank"
                    mat-list-item>
                    <fa-icon [icon]="['fas', 'question-circle']" />
                    @if (expanded()) {
                        Help
                    }
                </a>
            </mat-nav-list>
        </mat-sidenav>
    }
    <mat-sidenav-content id="content">
        <ng-content />
    </mat-sidenav-content>
</mat-sidenav-container>
